import React from 'react'
import Img from '@/lib/Img'
import logo from '@/images/stepuplogo.png'

const Employee = ({ name, title, image, email, bio }) => (
	<div className="richtext">
		<dt>
			<figure data-aos="fade-up" className="aspect-square rounded-full overflow-hidden">
				{image
					? <Img image={image} alt={name} />
					: <img src={logo} alt={title} />
				}
			</figure>

			<h3 data-aos="fade-up" data-aos-delay="100" className="h3 mt-4">
				{!!bio?.metaInfo?.slug.current
					? <a className="link" href={`/blog/${ bio?.metaInfo?.slug.current }`}>{name}</a>
					: name}
			</h3>
		</dt>

		{title && (
			<dd data-aos="fade-up" data-aos-delay="100">
				<p className="technical text-teal">{title}</p>
				{email && (
					<p><a className="link-hover text-teal text-sm" href={`mailto:${email}`}>{email}</a></p>
				)}
			</dd>
		)}
	</div>
)

export default Employee
